import { SpaceProps } from '@wrisk/styled-system'
import React, { FunctionComponent } from 'react'

import { getCoverLevelOption, getCurrentQuote } from '../../../domain'
import { TKey } from '../../../infrastructure/internationalisation'
import { useProposal } from '../../product/proposal/ProposalProvider'
import { PromotionBanner } from './PromotionBanner'
import { PromotionNotification } from './PromotionNotification'

const tKey = TKey('components.promotion-banner')

export const ProposalPromotionBanner: FunctionComponent<SpaceProps> = (props) => {
  const { proposal } = useProposal()

  const quote = getCurrentQuote(proposal)
  const promotion = getCoverLevelOption(quote)?.promotion
  const promoCode = quote.promoCode

  return promoCode && promotion ? (
    <PromotionBanner tKey={tKey} promoCode={promoCode} {...props} />
  ) : promoCode ? (
    <PromotionNotification promoCode={promoCode} {...props} />
  ) : null
}
